(() => {
 'use strict';
 if(window.__TOS295_EXPERIENCE__)return;
 const data=document.getElementById('tos-experience-295');if(!data)return;
 const config=JSON.parse(data.textContent),formats=config.formats;
 const api=()=>window.__R290_MEDIA__,money=n=>new Intl.NumberFormat('ro-RO',{style:'currency',currency:config.currency,currencyDisplay:'narrowSymbol'}).format(n/100);
 const identity='tos295-'+Date.now().toString(36),entries=new Map(),historyBound=new WeakSet();
 let dialog,lifecycleDialog,group,choice,price,subtitle,back,lastFormat=null,currentKey=null,serial=0,wasOpen=false,closing=false,afterClose=null,scheduled=0;
 const marker=()=>history.state?.__tos295;
 const own=m=>m?.owner===identity;
 function navigate(format){
  const form=document.getElementById('choice-form'),radio=form?.querySelector('input[data-format="'+format+'"]');
  if(radio&&!radio.disabled&&form.dataset.ready==='true'){
   radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));
   form.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
   radio.focus({preventScroll:true});return;
  }
  const url=new URL(config.destination,location.href);url.searchParams.set('variant',String(formats[format].id));location.assign(url.href);
 }
 function finishClose(){
  const action=afterClose;afterClose=null;closing=false;currentKey=null;
  // A fresh open can arrive while the preceding close's traversal is pending.
  // Give that new visit its own entry only after the old one has been removed.
  if(lifecycleDialog?.open&&api()?.active){wasOpen=true;beginHistory();schedule();}
  else if(action)requestAnimationFrame(action);
 }
 function close(action){const d=dialog||lifecycleDialog;if(!d?.open||closing)return;afterClose=action||null;if(action)d.dataset.r295Exit='choose';d.close();}
 function beginHistory(){
  const current=marker();
  if(own(current)){currentKey=current.key;return;}
  currentKey=identity+'-'+(++serial);entries.set(currentKey,api().opener);
  try{const previous=history.state&&typeof history.state==='object'?history.state:{};history.pushState({...previous,__tos295:{owner:identity,key:currentKey,format:api().active.format}},'');}
  catch{currentKey=null;}
 }
 function bindHistory(d){
  lifecycleDialog=d;if(historyBound.has(d))return;historyBound.add(d);
  d.addEventListener('close',()=>{
   wasOpen=false;const current=marker();
   if(currentKey&&own(current)&&current.key===currentKey){closing=true;history.back();}
   else finishClose();
  });
 }
 document.addEventListener('three-olives:gallery-open',e=>{
  const d=e.detail.dialog;bindHistory(d);wasOpen=true;lastFormat=e.detail.format;delete d.dataset.r295Exit;
  if(closing)afterClose=null;else beginHistory();
  schedule();
 });
 function sync(){
  scheduled=0;if(!dialog)return;
  if(!dialog.open){wasOpen=false;return;}
  if(!api()?.active)return;
  if(!wasOpen){wasOpen=true;delete dialog.dataset.r295Exit;if(!closing)beginHistory();}
  const format=api().active.format,item=formats[format];if(!item)return;
  lastFormat=format;group.hidden=false;
  group.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.r294Format===format)));
  price.textContent=money(item.price);subtitle.textContent=item.label;
  choice.textContent=item.available?config.choose.replace('{format}',item.label):config.unavailable;choice.disabled=!item.available;
  choice.setAttribute('aria-label',choice.textContent+' — '+money(item.price)+'. '+config.next);
  dialog.dataset.r295Format=format;
  if(own(marker())&&marker().key===currentKey&&marker().format!==format)history.replaceState({...history.state,__tos295:{...marker(),format}},'');
 }
 const schedule=()=>{if(!scheduled)scheduled=requestAnimationFrame(()=>{enhance();sync();});};
 function enhance(){
  const d=document.querySelector('.r293-dialog');if(!d||dialog===d)return;
  dialog=d;bindHistory(d);d.classList.add('r295-dialog');
  for(const [key,value]of Object.entries(config.tokens))d.style.setProperty('--r295-'+key,value);
  const options=d.querySelector('.r290-options'),modes=d.querySelector('.r290-modes');
  const heading=d.querySelector('.r290-title');heading.firstChild.textContent=config.title;
  subtitle=d.querySelector('.r290-subtitle');
  const selection=document.createElement('div');selection.className='r295-selection';
  group=document.createElement('div');group.className='r294-formats';group.setAttribute('role','group');group.setAttribute('aria-label',config.formatsLabel);
  for(const format of ['500','1000']){
   const button=document.createElement('button');button.type='button';button.dataset.r294Format=format;button.textContent=formats[format].label;button.setAttribute('aria-pressed','false');
   button.addEventListener('click',()=>{api().switchFormat(format);sync();});group.append(button);
  }
  const priceBox=document.createElement('div');priceBox.className='r295-price';price=document.createElement('strong');const vat=document.createElement('small');vat.textContent=config.vat;priceBox.append(price,vat);selection.append(group,priceBox);options.insertBefore(selection,modes);
  const purchase=document.createElement('div');purchase.className='r295-purchase';
  const actions=document.createElement('div');actions.className='r295-actions';
  back=document.createElement('button');back.type='button';back.className='r295-back';back.textContent=config.back;back.setAttribute('aria-label',config.backLabel);back.addEventListener('click',()=>close());
  choice=document.createElement('button');choice.type='button';choice.className='r295-choose';choice.dataset.r295Choose='';choice.addEventListener('click',()=>{const format=api()?.active?.format;if(formats[format]?.available)close(()=>navigate(format));});
  const next=document.createElement('p');next.className='r295-next';next.textContent=config.next;actions.append(back,choice);purchase.append(actions,next);options.append(purchase);
  d.querySelector('.r290-options>p').hidden=true;
  d.querySelector('[data-origin]').hidden=true;
  const coarse=matchMedia('(pointer:coarse)');
  const hint=()=>{const focus=window.__TOS293_FOCUS__;if(focus){focus.config.copy.fullHint=coarse.matches?config.hintTouch:config.hintPointer;if(d.dataset.detail!=='true')d.querySelector('[data-hint]').textContent=focus.config.copy.fullHint;}};hint();coarse.addEventListener('change',hint);
  api().bindTouchButtons(d);
  new MutationObserver(schedule).observe(d,{attributes:true,attributeFilter:['open']});
  new MutationObserver(schedule).observe(d.querySelector('.r290-view'),{attributes:true,attributeFilter:['data-format']});
  sync();
 }
 window.addEventListener('popstate',e=>{
  if(closing){finishClose();return;}
  const current=e.state?.__tos295,d=dialog||lifecycleDialog;
  if(own(current)&&!d?.open){currentKey=current.key;api()?.open(current.format,entries.get(current.key));enhance();sync();}
  else if(!own(current)&&d?.open)d.close();
 });
 document.addEventListener('change',e=>{if(e.target.matches?.('#choice-form input[data-format]')&&e.target.checked)lastFormat=e.target.dataset.format;});
 new MutationObserver(schedule).observe(document.body,{childList:true});
 enhance();
 window.__TOS295_EXPERIENCE__={enhance,sync,get lastFormat(){return lastFormat;},get dialog(){return dialog;}};
})();
